import { Button, Container, Typography } from "@mui/material";

const ShowSystemNotification = (props: any) => {
    const { title, message, fireDate } = props.id;
    return (<Container>
        <div className="flex flex-col gap-2 min-w-80">
            <div className="flex justify-between gap-2">
                <Typography>{title}</Typography>
                {/* <Typography>{fireDate}</Typography> */}

            </div>
            <div className="flex flex-nowrap overflow-hidden w-80 text-wrap">
                <Typography variant="overline" className="text-wrap min-w-80"><pre>{message}</pre></Typography>

            </div>
        </div>


    </Container >);
}

export default ShowSystemNotification;